import { useEffect, useState } from "react";
import { BRAND } from "@/lib/site";

const NAV = [
  { id: "sobre", label: "Sobre" },
  { id: "procedimentos", label: "Serviços" },
  { id: "espaco", label: "Espaço" },
  { id: "depoimentos", label: "Depoimentos" },
  { id: "localizacao", label: "Localização" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-black/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="font-bebas text-3xl tracking-[0.08em] text-black uppercase"
        >
          {BRAND.name}
          <span className="ml-2 text-[10px] tracking-[0.3em] uppercase text-neutral-500 align-middle font-sans">
            · Studio
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`nav-link-${item.id}`}
              className="link-underline text-[11px] tracking-[0.25em] uppercase text-neutral-700 hover:text-black"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href={BRAND.bookingUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="header-cta-book"
          className="hidden md:inline-flex items-center gap-2 bg-black text-white px-6 py-3 text-[11px] tracking-[0.25em] uppercase hover:bg-neutral-800 transition-colors"
        >
          Agendar
        </a>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className="md:hidden h-10 w-10 flex flex-col items-center justify-center gap-1.5"
          aria-label="Menu"
        >
          <span className={`block h-px w-6 bg-black transition-transform ${open ? "rotate-45 translate-y-[3px]" : ""}`} />
          <span className={`block h-px w-6 bg-black transition-transform ${open ? "-rotate-45 -translate-y-[3px]" : ""}`} />
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-black/10" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.2em] uppercase text-neutral-700"
                data-testid={`mobile-nav-link-${item.id}`}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
